<template>
</template>

<script>
</script>

<style>
</style>
<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：插件中心-限时拼团-活动列表-添加活动
      -->
  <div>
    <div class="product-content">
      <el-form size="small" ref="form"  :model="form" label-width="150px">
        <!--基础设置-->
        <Basic :form="form"></Basic>



        <!--打卡规则-->
        <Clock :form="form"></Clock>

        <!--其它-->
        <Other :form="form"></Other>
      </el-form>
    </div>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" @click="cancelFunc">取消</el-button>
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
    </div>
  </div>
</template>
<script>
import SweepstakesApi from '@/api/sweepstakes.js';
import Basic from './part/Basic.vue';

import Clock from './part/Clock.vue';
import Other from './part/Other.vue';
export default {
  components: {
    /*基础设置*/
    Basic,

    /*活动商品*/
    Clock,
    /*其它*/
    Other
  },
  data() {
    return {
      form: {
        /*活动名称*/
        sweepstakes_name: '',
        /*广告图片ID*/
        image_id: 0,
        /*抽奖转盘图片ID*/
        turntable_id:0,
        type:10,
        /*活动广告图*/
        file_path:'',
        turntable_path:'',
        gradeList:[],
        /*是否生效，默认1为生效，0为不生效*/
        status: 1,
        /*默认排序*/
        sort: 100,
        /*打卡规则介绍*/
        sweepstakes_content:'',
        /*打卡规则设置*/
        sweepstakes_rules:{

          /*抽奖选项*/
          reward_data: [],

        },
        /*抽奖选项*/
        awards:[],
        /*等级限抽*/
        grade_limit:[],
      },
      /*判断是否正在加载*/
      loading: false,


    };
  },
  created() {
    this.form.sweepstakes_id = this.$route.query.sweepstakes_id;
    this.getData();
  },
  methods: {
    /*获取编辑数据*/
    getData() {
      let self = this;
      self.loading = true;
      SweepstakesApi.editSweepstakes({
        sweepstakes_id: self.form.sweepstakes_id
      }, true )
        .then(res => {
          self.form = res.data.model;
          self.form.gradeList = res.data.gradeList;
          if(!self.form.grade_limit){
            self.form.grade_limit = [];
          }
          if(self.form.sweepstakes_rules.reward_data){
            self.form.sweepstakes_rules.reward_data.forEach(item=>{
              if(item.is_point){
                if(item.is_point =='true'){
                  item.is_point =true
                }else{
                  item.is_point =false
                }
              }
              if(item.is_product){
                if(item.is_product =='true'){
                  item.is_product =true
                }else{
                  item.is_product =false
                }
              }
              if(item.is_image){
                if(item.is_image =='true'){
                  item.is_image =true
                }else{
                  item.is_image =false
                }
              }
            })
          }
          if(typeof(self.form.sweepstakes_rules.consume_points) == "string"){
            self.form.sweepstakes_rules.consume_points = []
          }

          if(self.form.sweepstakes_rules.consume_points!=null&&typeof self.form.sweepstakes_rules.consume_points !='undefined'){
            if(res.data.gradeList){
              res.data.gradeList.forEach(item=>{

                item.points= self.form.sweepstakes_rules.consume_points[item.grade_id]?parseInt(self.form.sweepstakes_rules.consume_points[item.grade_id]):0;


              });
            }
          }
          if(self.form.grade_limit == null){
            self.form.grade_limit = [];
          }
          if(self.form.grade_limit.length > 0){
            for (let i = 0; i < self.form.grade_limit.length; i++) {
              self.form.grade_limit[i] = parseInt(self.form.grade_limit[i])
             }
          }
          if(res.data.model.file){
            self.form.file_path = res.data.model.file.file_path;
          }
          if(res.data.model.lotterBg){
            self.form.turntable_path = res.data.model.lotterBg.file_path;
          }
          self.loading = false;

        })
        .catch(error => {
          self.loading = false;
        });
    },
    convertJson(list){
      let obj={};
      list.forEach(item=>{
        obj[item.grade_id]=item.points;
      });
      return obj;
    },

    /*提交表单*/
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.form.sweepstakes_rules.consume_points = self.convertJson(self.form.gradeList);
          let params = self.form;
          // console.log(params);
          // return;
          self.loading = true;
          SweepstakesApi.saveSweepstakes(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，编辑成功',
                type: 'success'
              });
              self.$router.push('/plus/sweepstakes/sweepstakes/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*表格数据格式化*/
    tableFormet(list) {
      let spec_list = [];
      let newList = [];
      let curItem = null;
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let obj = {
          product_sku_id: item.product_sku_id,
          assemble_stock: item.assemble_stock,
          assemble_price: item.assemble_price,
          product_attr: item.spec_name,
          assemble_product_sku_id:item.assemble_product_sku_id,
          product_price:item.product_price,
          sales_initial:item.sales_initial
        };
        if (curItem == null) {
          curItem = item;
        }
        if (curItem.product_id != item.product_id) {
          curItem.spec_list = spec_list;
          newList.push(curItem);
          curItem = item;
          spec_list = [];
        }
        spec_list.push(obj);
      }
      curItem.spec_list = spec_list;
      newList.push(curItem);
      return newList;
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/sweepstakes/edit.vue